import { ARTICLE_TYPE, Story } from "~types/types";

import { getEyebrowLink } from "./eyebrowUtil";
import getArticleType from "./getArticleType";
import isOpinion from "./isOpinion";

export const getShouldShowAITakeaways = (story: Story) => {
    const isFullArray =
        Array.isArray(story.aiSummary?.text) &&
        story.aiSummary?.text.length !== 0;
    const { text } = getEyebrowLink(story);

    return (
        story.aiSummary &&
        story.aiSummary?.text &&
        isFullArray &&
        !isOpinion(story) &&
        getArticleType(story) !== ARTICLE_TYPE.EXPLAINERS &&
        story.franchise !== "explainer" &&
        getArticleType(story) !== ARTICLE_TYPE.NEWSLETTER &&
        text !== "Newsletter" &&
        !story.nicodes?.includes("GLOBEWRP") &&
        !story.nicodes?.includes("WKNDEDIT")
    );
};
